const compareScreen = (item1, item2) => {
  const FOV_WEIGHT = 3;
  const RR_WEIGHT = 2;
  const RES_WEIGHT = 4;
  const PD_WEIGHT = 1;
  const IPD_WEIGHT = 1;

  const itemWeight = (item, compareResult) => {
    let weight = 0;
    if (item.fov === compareResult.fov) {
      weight += FOV_WEIGHT;
    }
    if (item.refreshrate === compareResult.rr) {
      weight += RR_WEIGHT;
    }
    if (item.resolution.x === compareResult.res.x && item.resolution.y === compareResult.res.y) {
      weight += RES_WEIGHT;
    }
    if (item.pixeldensity === compareResult.pd) {
      weight += PD_WEIGHT;
    }
    if (item.ipd === compareResult.ipd) {
      weight += IPD_WEIGHT;
    }
    return weight;
  };

  const compareFov = (fov1, fov2) => {
    if (!fov1) return fov2;
    if (!fov2) return fov1;
    return fov1 > fov2 ? fov1 : fov2;
  };

  const compareRefreshrate = (rr1, rr2) => {
    if (!rr1) return rr2;
    if (!rr2) return rr1;
    return rr1 > rr2 ? rr1 : rr2;
  };

  const compareResolution = (res1, res2) => {
    if (!res1) return res2;
    if (!res2) return res1;

    return res1.x * res1.y > res2.x * res2.y ? res1 : res2;
  };

  const comparePixelDensity = (pd1, pd2) => {
    if (!pd1) return pd2;
    if (!pd2) return pd1;
    return pd1 > pd2 ? pd1 : pd2;
  };

  const compareResult = {
    fov: compareFov(item1.fov, item2.fov),
    rr: compareRefreshrate(item1.refreshrate, item2.refreshrate),
    res: compareResolution(item1.resolution, item2.resolution),
    pd: comparePixelDensity(item1.pixeldensity, item2.pixeldensity),
    ipd: true,
  };

  const itemWeight1 = itemWeight(item1, compareResult);
  const itemWeight2 = itemWeight(item2, compareResult);

  if (itemWeight1 === itemWeight2) {
    return [item1, item2];
  }
  return itemWeight1 > itemWeight2 ? [item1] : [item2];
};

module.exports = compareScreen;
